import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor() { }

  downloadFile(fileName: string, data: any): void {
    let blob = new Blob([data]);
    let downloadURL = URL.createObjectURL(blob);
    let link = document.createElement('a');
    link.href = downloadURL;
    link.download = (new Date().getTime()).toString() + '_' + fileName;
    link.click();
  }

  public openBlobFile(data: Blob): void {
    let downloadURL = URL.createObjectURL(data);
    let link = document.createElement('a');
    link.href = downloadURL;
    link.target = '_blank';
    link.click();
  }

  isImageFile(file: File): boolean {
    return file.type.includes('image');
  }

  isPDFFile(file: File): boolean {
    return file.name.split(".")
      .pop()
      ?.toLowerCase() == "pdf";
  }

  isExcelFile(file: File): boolean {
    const extension = "." + (file.name.split(".")
      .pop()?.toLowerCase() || "");
    return ['.xlsx', '.xlsm', '.xlsb', '.xls', '.xml', '.xlr', '.csv'].includes(extension);
  }

  getFileSizeInMB(file: File): number {
    return file.size / (1024 * 1024)
  }

  printFile(blob: Blob): void {
    this.openBlobFile( blob);
    //load content in an iframe to print later
    const iframe =  document.createElement('iframe');
    document.body.appendChild(iframe);
    iframe.style.display = 'none';
    iframe.src = URL.createObjectURL(blob);
    iframe.onload = function() {
      setTimeout(function() {
        iframe.focus();
        iframe.contentWindow?.print();
      }, 1);
    };
  }

}
